import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {UserBusinessDto} from '../../../models/generated-models';

@Injectable({ providedIn: 'root' })
export class UserBusinessApiService {
  private readonly http = inject(HttpClient);

  listBusinesses(): Observable<UserBusinessDto[]> {
    return this.http.get<UserBusinessDto[]>(`${environment.serverUrl}/api/businesses`);
  }

  createBusiness(payload: UserBusinessDto): Observable<UserBusinessDto> {
    return this.http.post<UserBusinessDto>(`${environment.serverUrl}/api/businesses`, payload);
  }
}
